var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRisksSuggestionsChecks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6443 5.32909C19.1057 5.78034 19.1201 6.52659 18.6764 6.99589L8.84278 17.397C8.07193 18.2124 6.78508 18.199 6.03073 17.3679L2.30739 13.2655C1.87319 12.7871 1.90253 12.0413 2.37292 11.5997C2.84331 11.1581 3.57662 11.188 4.01082 11.6664L7.456 15.4623L17.0054 5.36178C17.4491 4.89248 18.1828 4.87784 18.6443 5.32909Z",
    fill: "#C1C6C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9965 7.62537C22.4583 8.06454 22.4766 8.79489 22.0374 9.25666L13.99 17.7183C13.5508 18.1801 12.8205 18.1984 12.3587 17.7593C11.8969 17.3201 11.8786 16.5897 12.3178 16.128L20.3652 7.6663C20.8044 7.20453 21.5347 7.1862 21.9965 7.62537Z",
    fill: "#C1C6C8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRisksSuggestionsChecks);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risks_suggestions_checks.c0b055376dd36eb3db23af743a71a9b8.svg";